import { render, staticRenderFns } from "./content4.vue?vue&type=template&id=4f55625a&scoped=true&"
import script from "./content4.vue?vue&type=script&lang=js&"
export * from "./content4.vue?vue&type=script&lang=js&"
import style0 from "./content4.vue?vue&type=style&index=0&id=4f55625a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55625a",
  null
  
)

export default component.exports